import { Immutable } from "immer";
import React from "react";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import { IMenuPromo } from "../../utils/menu.interface";

import styles from "./index.module.scss";

type IProps = Immutable<{
    promoArrayEl: IMenuPromo;
}>;

export const PromoAd = ({ promoArrayEl }: IProps): React.ReactNode => {
    let link;
    let imageContent: React.JSX.Element | null = null;
    let customHTMLContent: React.JSX.Element | null = null;

    if (promoArrayEl.value.page || promoArrayEl.value.external_link) {
        link = promoArrayEl.value.page
            ? promoArrayEl.value.page.url
            : promoArrayEl.value.external_link;
    }

    if (promoArrayEl.value.image !== null) {
        if (promoArrayEl.value.image.url) {
            imageContent = (
                <div className={styles.mainDropdownMenuAdImageContainer}>
                    <img
                        src={promoArrayEl.value.image.url}
                        alt={promoArrayEl.value.image.title}
                    />
                </div>
            );
        }
    }

    if (promoArrayEl.value.html) {
        customHTMLContent = (
            <EditorContent>
                {(marker) => (
                    <div
                        className={styles.mainDropdownMenuAdContent}
                        dangerouslySetInnerHTML={{
                            __html: promoArrayEl.value.html,
                        }}
                        {...marker}
                    ></div>
                )}
            </EditorContent>
        );
    }

    if (link) {
        // Need link title since content is an image. See #13290
        return (
            <a href={link} className={styles.mainDropdownMenuAd}>
                {imageContent}
                {customHTMLContent}
            </a>
        );
    }

    return (
        <div className={styles.mainDropdownMenuAd}>
            {imageContent}
            {customHTMLContent}
        </div>
    );
};
